import React, { createContext, useContext, useReducer } from 'react'

export const StoreContext = createContext()

export const StoreProvider = ({ reducer, initialState, children }) => (
    <StoreContext.Provider value={useReducer(reducer, initialState)}>{children}</StoreContext.Provider>
)

// useStore hook 会返回 useContext，以获取当前的context值（即useReducer的返回，store和dispatch）
export const useStore = () => useContext(StoreContext)
